import './course-content.css';

function CourseContent() {
    return (
        <>
            <h1>Courses</h1>

            
        </>
    );
}

export default CourseContent;